import { FC } from 'react'

import Image from 'next/image'

type EmptyStateProps = {
  children?: React.ReactNode
  backgroundColor?: string
}

const EmptyState: FC<EmptyStateProps> = ({
  children,
  backgroundColor = '#F8F9FA',
}): JSX.Element => (
  <div
    id="empty-state"
    className="flex flex-col flex-wrap p-6 justify-center items-center gap-4 rounded-xl w-full"
    style={{ minWidth: '260px', background: backgroundColor }}
  >
    <span
      id="empty-state-wrapper"
      className="flex flex-col max-w-xs items-center gap-3 text-center"
      style={{ flex: '1 0 0' }}
    >
      <Image
        id="empty-state-avatar"
        src="/placeholder_avatar.svg"
        width={40}
        height={40}
        alt="placeholder avatar"
      />
      <span
        id="empty-state-text"
        className="flex flex-col items-center self-stretch"
      >
        {children}
      </span>
    </span>
  </div>
)

export default EmptyState
